import { DeviceOutput } from "../../../../../devices/models/device_output";

export interface CallEntity {

    id: string;

    kind: CallEntityKind;

}

/**
 * Extended call participant with all information needed for a call.
 * Used by components to specify caller and callee when starting a call.
 */
export interface CallParticipant extends CallEntity {
    /** Display name of the participant */
    name?: string;
    /** Available outputs (for doorstations) */
    outputs?: DeviceOutput[];
    /** AWS IoT thing name (for devices) */
    thingName?: string;
    /** Whether the device supports V2 call protocol (firmware >= 2.0.0) */
    isV2?: boolean;
}

// export type CallEntityKind = "doorstation" | "intercom" | "unit" | "pbx";

export enum CallEntityKind {
    Doorstation = "doorstation",
    Intercom = "intercom",
    Unit = "unit",
    PBX = "pbx"
}
